/* eslint-disable @typescript-eslint/no-explicit-any */
// unfortunately, we can't edit the signature of LocalizeParser so "any" type it is
import { LocalizeParser, LocalizeRouterSettings } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { Routes } from '@angular/router';
import { Location } from '@angular/common';

export class LocalizeUniversalLoader extends LocalizeParser {
  constructor(
    translate: TranslateService,
    location: Location,
    settings: LocalizeRouterSettings,
    private platformService: PlatformInformationService,
    private acceptedLanguages?: Array<string>
  ) {
    super(translate, location, settings);
  }

  /**
   * Gets config from the server
   */
  public load(_routes: Routes): Promise<any> {
    return new Promise((resolve: any) => {
      this.prefix = 'ROUTES.';
      if (this.acceptedLanguages) {
        this.locales = this.acceptedLanguages;
        this.init(_routes).then(resolve);
      } else {
        this.platformService.data$.subscribe(config => {
          this.locales = config.acceptedLanguages;
          this.init(_routes).then(resolve);
        });
      }
    });
  }
}
